import styles from './FJClothesChangerRight.module.less';
import PropTypes from 'prop-types';
import FJDragBox from '../../../common/components/FJDragBox/FJDragBox';
import FJCreationPanelContainer from '../../FJMainPreview/FJCreationPanel/FJCreationPanelContainer.jsx';
import FJHistoryPanelContainer from '../../FJMainPreview/FJHistoryPanel/FJHistoryPanelContainer.jsx';
import FJDisplayHeaderContainer from '../../FJMainPreview/FJDisplayHeader/FJDisplayHeaderContainer.jsx';

const FJClothesChangerRight = props => {
    const { uploadImg, setIsDraggingFile, reGenerate } = props;

    return (
        <FJDragBox setIsDragging={setIsDraggingFile} uploadFile={uploadImg} className={styles.app_right}>
            <FJDisplayHeaderContainer hideCancelButton={true} />
            <FJCreationPanelContainer activeHeaderTabIndex={0} onRetry={reGenerate} />
            <FJHistoryPanelContainer activeHeaderTabIndex={1} />
        </FJDragBox>
    );
};
FJClothesChangerRight.propTypes = {
    uploadImg: PropTypes.func,
    setIsDraggingFile: PropTypes.func,
    reGenerate: PropTypes.func,
};
export default FJClothesChangerRight;
